import {API_URL, handleErrorResponse} from "../utility/utility";

export async function findEventGroupsWithPagination(page, limit, filterStatus = null, signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);

    if (filterStatus) {
        params.append('status', filterStatus);
    }

    const queryString = params.toString();

    const response = await fetch(`${API_URL}/api/event-groups?${queryString}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch event groups');

    return response.json();
}

export async function findProductsWithPagination(page, limit, filterStatus = null, filterName = null, signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const params = new URLSearchParams();
    if (filterStatus) {
        params.append('status', filterStatus);
    }
    if (filterName) {
        params.append('name', filterName);
    }
    params.append('page', page);
    params.append('limit', limit);

    const queryString = params.toString();

    const response = await fetch(`${API_URL}/api/products?${queryString}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch products');

    return response.json();
}

export async function findCustomerProductsWithPagination(page, limit, customerId = null, filterFirstName = null, filterLastName = null, signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);

    if (customerId) {
        params.append('customerId', customerId);
    }

    if (filterFirstName) {
        params.append('firstName', filterFirstName);
    }

    if (filterLastName) {
        params.append('lastName', filterLastName);
    }

    const queryString = params.toString();

    const response = await fetch(`${API_URL}/api/customer-products?${queryString}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch customer products');

    return response.json();
}

export async function createInvoice(orderId) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/invoices`, {
        method  : 'POST',
        body    : JSON.stringify({orderId : orderId}),
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to create invoice');
}

export async function cancelOrder(orderId) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/orders/${orderId}/cancel`, {
        method  : 'POST',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to cancel order');
}

export async function markOrderPickedUp(orderId) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/orders/${orderId}/mark-picked-up`, {
        method  : 'PATCH',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to mark order as picked up');
}

export async function findInvoicesWithPagination(page, limit, customerId = null, signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);

    if (customerId) {
        params.append('customerId', customerId);
    }

    const queryString = params.toString();

    const response = await fetch(`${API_URL}/api/invoices?${queryString}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch invoices');

    return response.json();
}

export async function findPaymentsWithPagination(page, limit, customerId = null, fromDate = null, toDate = null, signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);

    if (customerId) {
        params.append('customerId', customerId);
    }

    if (fromDate) {
        params.append('fromDate', fromDate);
    }

    if (toDate) {
        params.append('toDate', toDate);
    }

    const queryString = params.toString();

    const response = await fetch(`${API_URL}/api/payments?${queryString}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch payments');

    return response.json();
}

export async function findOrdersWithPagination(page, limit, customerId = null, paymentStatus = null, fromDate = null, toDate = null, signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);

    if (customerId) {
        params.append('customerId', customerId);
    }

    if (paymentStatus) {
        params.append('paymentStatus', paymentStatus);
    }

    if (fromDate) {
        params.append('fromDate', fromDate);
    }

    if (toDate) {
        params.append('toDate', toDate);
    }

    const queryString = params.toString();

    const response = await fetch(`${API_URL}/api/orders?${queryString}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch orders');

    return response.json();
}

export async function findPayableOrders(customerId, signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/orders/payable?customerId=${customerId}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch payable orders');

    return response.json();
}

export async function getOrdersTotal(fromDate = null, toDate = null, signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const params = new URLSearchParams();
    if (fromDate) {
        params.append('fromDate', fromDate);
    }

    if (toDate) {
        params.append('toDate', toDate);
    }

    const queryString = params.toString();

    const response = await fetch(`${API_URL}/api/orders/total?${queryString}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch total orders');

    return await response.json();
}

export async function getCustomerProduct(customerProductId) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/customer-products/${customerProductId}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to fetch customer product');

    return await response.json();
}

export async function updateCustomerProduct(customerProductId, credits = null, expiredAt = null) {
    if (!customerProductId) {
        throw new Error("The customerProductId is required.");
    }

    const token = localStorage.getItem('ACCESS_TOKEN');

    let data = {};
    if (credits) {
        data.credits = credits;
    }
    if (expiredAt) {
        data.expiredAt = expiredAt;
    }

    if (Object.keys(data).length === 0) {
        throw new Error("At least one field is required.");
    }

    const response = await fetch(`${API_URL}/api/customer-products/${customerProductId}`, {
        method  : 'PATCH',
        body    : JSON.stringify(data),
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to update customer product');
}

export async function createCustomerProduct(
    customerId,
    productId,
    orderDate,
    paymentMethod,
    activationType = null
) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const data = {
        customerId    : customerId,
        productId     : productId,
        orderDate     : orderDate,
        paymentMethod : paymentMethod
    }

    if (activationType) {
        data.activationType = activationType;
    }

    const response = await fetch(`${API_URL}/api/customer-products`, {
        method  : 'POST',
        body    : JSON.stringify(data),
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to create customer product');
}

export async function createPayment(customerId, orderId, paymentMethod, paymentDate) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/payments`, {
        method  : 'POST',
        body    : JSON.stringify({
            customerId    : customerId,
            orderId       : orderId,
            paymentMethod : paymentMethod,
            paymentDate   : paymentDate
        }),
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to create payment');
}

export async function findBookingGroupsWithPagination(page, limit, signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);

    const queryString = params.toString();

    const response = await fetch(`${API_URL}/api/booking-groups?${queryString}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch booking groups');

    return response.json();
}

export async function findBookingGroupsAll(signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/booking-groups-all`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch booking groups');

    return response.json();
}

export async function getEventGroup(eventGroupId) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/event-groups/${eventGroupId}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to fetch event group');

    return await response.json();
}

//getBookingGroup
export async function getBookingGroup(bookingGroupId) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/booking-groups/${bookingGroupId}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to fetch booking group');

    return await response.json();
}

export async function getProduct(productId) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/products/${productId}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to fetch product');

    return await response.json();
}

export async function getInvoice(invoiceId) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/invoices/${invoiceId}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to fetch invoice');

    return await response.json();
}

export async function getInvoicePdf(invoiceId) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/invoices/${invoiceId}/pdf`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/pdf',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to fetch invoice pdf');

    return await response.blob();
}

export async function getEvent(eventId) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/events/${eventId}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to fetch event');

    return await response.json();
}

export async function updateEvent(
    eventId,
    name = null,
    seats = null,
    trainerIds = null,
    startedAt = null,
    endedAt = null
) {
    if (!eventId) {
        throw new Error("The eventId is required.");
    }

    const token = localStorage.getItem('ACCESS_TOKEN');

    let data = {};

    if (name) {
        data.name = name;
    }

    if (seats) {
        data.seats = seats;
    }

    if (trainerIds) {
        data.trainerIds = trainerIds;
    }

    if (startedAt) {
        data.startedAt = startedAt;
    }

    if (endedAt) {
        data.endedAt = endedAt;
    }

    if (Object.keys(data).length === 0) {
        throw new Error("At least one field is required.");
    }

    const response = await fetch(`${API_URL}/api/events/${eventId}`, {
        method  : 'PATCH',
        body    : JSON.stringify(data),
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to update event');
}

export async function createEventGroup(eventType, locationId, name, seats, color, cancellationCreditRefundPeriod, requiresSmartLock, description = null, image = null) {
    if (!eventType || !locationId || !name || !seats || !color || !cancellationCreditRefundPeriod || requiresSmartLock === null || requiresSmartLock === undefined) {
        throw new Error("All fields except 'description' and 'image' are required.");
    }

    const token = localStorage.getItem('ACCESS_TOKEN');

    // Create FormData for file upload
    const formData = new FormData();
    formData.append('eventType', eventType);
    formData.append('locationId', locationId);
    formData.append('name', name);
    formData.append('seats', seats);
    formData.append('color', color);
    formData.append('cancellationCreditRefundPeriod', cancellationCreditRefundPeriod);
    formData.append('requiresSmartLock', requiresSmartLock);

    // Append optional fields
    if (description) {
        formData.append('description', description);
    }
    if (image) {
        formData.append('image', image);
    }

    const response = await fetch(`${API_URL}/api/event-groups`, {
        method  : 'POST',
        body    : formData,
        headers : {
            'Accept'        : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to create event group');
}

//createBookingGroup(name, eventGroupIds)
export async function createBookingGroup(name, eventGroupIds) {
    if (!name || !eventGroupIds) {
        throw new Error("All fields are required.");
    }

    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/booking-groups`, {
        method  : 'POST',
        body    : JSON.stringify({
            name          : name,
            eventGroupIds : eventGroupIds
        }),
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to create booking group');
}

export async function createProduct(
    productType,
    name,
    description,
    bruttoPrice,
    isRestrictedOnePerUser,
    isPublic,
    order,
    isShopVisibleAfterStart = null,
    credit = null,
    validity = null,
    activationType = null,
    validityUnit = null,
    eventGroupId = null,
    eventIds = null,
    bookingGroupIds = null,
    maxSellableQuantity = null
) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const data = {
        productType            : productType,
        name                   : name,
        description            : description,
        bruttoPrice            : bruttoPrice,
        isRestrictedOnePerUser : isRestrictedOnePerUser,
        isPublic               : isPublic,
        order                  : order
    }

    // Leaving the field out means unlimited, which is what null stands for
    // here; 0 is a real value meaning the product is sold out right away.
    if (maxSellableQuantity !== null) {
        data.maxSellableQuantity = maxSellableQuantity;
    }

    if (isShopVisibleAfterStart !== null) {
        data.isShopVisibleAfterStart = isShopVisibleAfterStart;
    }

    if (credit !== null) {
        data.credit = credit;
    }

    if (validity !== null) {
        data.validity = validity;
    }

    if (activationType !== null) {
        data.activationType = activationType;
    }

    if (validityUnit !== null) {
        data.validityUnit = validityUnit;
    }

    if (eventGroupId !== null) {
        data.eventGroupId = eventGroupId;
    }

    if (eventIds !== null) {
        data.eventIds = eventIds;
    }

    if (bookingGroupIds !== null) {
        data.bookingGroupIds = bookingGroupIds;
    }

    const response = await fetch(`${API_URL}/api/products`, {
        method  : 'POST',
        body    : JSON.stringify(data),
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to create product');
}

export async function updateEventGroup(eventGroupId, locationId = null, name = null, seats = null, color = null, description = null, cancellationCreditRefundPeriod = null, image = null, requiresSmartLock = null) {
    if (!eventGroupId) {
        throw new Error("The eventGroupId is required.");
    }

    const token = localStorage.getItem('ACCESS_TOKEN');

    // Create FormData for file upload
    const formData = new FormData();
    if (locationId) {
        formData.append('locationId', locationId);
    }
    if (name) {
        formData.append('name', name);
    }
    if (seats) {
        formData.append('seats', seats);
    }
    if (color) {
        formData.append('color', color);
    }
    if (description) {
        formData.append('description', description);
    }
    if (cancellationCreditRefundPeriod) {
        formData.append('cancellationCreditRefundPeriod', cancellationCreditRefundPeriod);
    }
    if (image) {
        formData.append('image', image);
    } // Append the file if provided
    if (requiresSmartLock !== null) {
        formData.append('requiresSmartLock', requiresSmartLock);
    }

    const response = await fetch(`${API_URL}/api/event-groups/${eventGroupId}`, {
        method  : 'POST',
        body    : formData,
        headers : {
            'Accept'        : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to update event group');
}

export async function updateBookingGroup(bookingGroupId, name, eventGroupIds) {
    if (!bookingGroupId || !name || !eventGroupIds) {
        throw new Error("All fields are required.");
    }

    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/booking-groups/${bookingGroupId}`, {
        method  : 'PATCH',
        body    : JSON.stringify({
            name          : name,
            eventGroupIds : eventGroupIds
        }),
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to update booking group');
}

export async function updateProduct(
    productId,
    name = null,
    description = null,
    bruttoPrice = null,
    isRestrictedOnePerUser = null,
    isPublic = null,
    order = null,
    isShopVisibleAfterStart = null,
    credit = null,
    validity = null,
    activationType = null,
    validityUnit = null,
    eventGroupId = null,
    eventIds = null,
    bookingGroupIds = null,
    maxSellableQuantity = undefined
) {
    if (!productId) {
        throw new Error("The productId is required.");
    }

    const token = localStorage.getItem('ACCESS_TOKEN');

    const data = {};

    if (name !== null) {
        data.name = name;
    }

    if (description !== null) {
        data.description = description;
    }

    if (bruttoPrice !== null) {
        data.bruttoPrice = bruttoPrice;
    }

    if (isRestrictedOnePerUser !== null) {
        data.isRestrictedOnePerUser = isRestrictedOnePerUser;
    }

    if (isPublic !== null) {
        data.isPublic = isPublic;
    }

    if (order !== null) {
        data.order = order;
    }

    if (isShopVisibleAfterStart !== null) {
        data.isShopVisibleAfterStart = isShopVisibleAfterStart;
    }

    if (credit !== null) {
        data.credit = credit;
    }

    if (validity !== null) {
        data.validity = validity;
    }

    if (activationType !== null) {
        data.activationType = activationType;
    }

    if (validityUnit !== null) {
        data.validityUnit = validityUnit;
    }

    if (eventGroupId !== null) {
        data.eventGroupId = eventGroupId;
    }

    if (eventIds !== null) {
        data.eventIds = eventIds;
    }

    if (bookingGroupIds !== null) {
        data.bookingGroupIds = bookingGroupIds;
    }

    // null clears the limit back to unlimited, so undefined - not null - is
    // what marks this field as "leave it as it is".
    if (maxSellableQuantity !== undefined) {
        data.maxSellableQuantity = maxSellableQuantity;
    }

    if (Object.keys(data).length === 0) {
        throw new Error("At least one field is required.");
    }

    const response = await fetch(`${API_URL}/api/products/${productId}`, {
        method  : 'PATCH',
        body    : JSON.stringify(data),
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to update product');
}

export async function deleteProduct(productId) {
    if (!productId) {
        throw new Error("The productId is required.");
    }

    const token = localStorage.getItem('ACCESS_TOKEN');

    await fetch(`${API_URL}/api/products/${productId}`, {
        method  : 'DELETE',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });
}

export async function findEventTypes(signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/event-types`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch event types');

    return response.json();
}

export async function findEventGroupEvents(eventGroupId, signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/event-groups/${eventGroupId}/events`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch events');

    return response.json();
}

export async function findProductTypes(signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/product-types`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch product types');

    return response.json();
}

export async function findProductActivationTypes(signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/product-activation-types`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch product activation types');

    return response.json();
}

export async function findPaymentMethods(onlyManual, signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const params = new URLSearchParams();
    if (onlyManual) {
        params.append('onlyManual', 1);
    }

    const queryString = params.toString();

    const response = await fetch(`${API_URL}/api/order-payment-methods?${queryString}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch order payment methods');

    return response.json();
}

export async function findProductValidityUnits(signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/product-validity-units`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch product validity units');

    return response.json();
}

export async function findEventGroups(eventType, signal = null) {
    if (eventType === null) {
        throw new Error("The eventType is required.");
    }
    const token = localStorage.getItem('ACCESS_TOKEN');

    const params = new URLSearchParams();
    params.append('eventType', eventType);

    const queryString = params.toString();

    const response = await fetch(`${API_URL}/api/event-groups-all?${queryString}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch event groups all');

    return response.json();
}

export async function findLocationsWithPagination(page, limit, signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);

    const queryString = params.toString();

    const response = await fetch(`${API_URL}/api/locations?${queryString}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch locations');

    return response.json();
}

export async function findEventSeriesWithPagination(
    eventGroupId,
    page,
    limit,
    filterStatus,
    signal = null
) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);

    if (filterStatus) {
        params.append('status', filterStatus);
    }

    const queryString = params.toString();

    const response = await fetch(`${API_URL}/api/event-groups/${eventGroupId}/event-series?${queryString}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch event series');

    return response.json();
}

export async function findBookingsWithPagination(eventId, status, page, limit, signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);
    params.append('eventId', eventId);

    if (status) {
        params.append(status, 1);
    }

    const queryString = params.toString();

    const response = await fetch(`${API_URL}/api/bookings?${queryString}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch bookings');

    return response.json();
}

export async function createEventSeries(
    eventGroupId,
    startDate,
    startTime,
    endTime,
    trainers,
    endDate = null,
    monday = null,
    tuesday = null,
    wednesday = null,
    thursday = null,
    friday = null,
    saturday = null,
    sunday = null
) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/event-series`, {
        method  : 'POST',
        body    : JSON.stringify({
            eventGroupId : eventGroupId,
            startDate    : startDate,
            startTime    : startTime,
            endTime      : endTime,
            endDate      : endDate,
            monday       : monday,
            tuesday      : tuesday,
            wednesday    : wednesday,
            thursday     : thursday,
            friday       : friday,
            saturday     : saturday,
            sunday       : sunday,
            trainers     : trainers
        }),
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to create event series');
}

export async function createBooking(eventId, customerId, withProduct) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/bookings`, {
        method  : 'POST',
        body    : JSON.stringify({
            eventId     : eventId,
            customerId  : customerId,
            withProduct : withProduct
        }),
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to create booking');
}

export async function updateEventSeries(
    eventSeriesId,
    endDate = null,
    trainers = null
) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/event-series/${eventSeriesId}`, {
        method  : 'PATCH',
        body    : JSON.stringify({
            endDate  : endDate,
            trainers : trainers
        }),
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to update event series');
}

export async function getEventSeries(eventSeriesId) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/event-series/${eventSeriesId}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to fetch event series');

    return await response.json();
}

export async function cancelEventSeries(eventSeriesId) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/event-series/${eventSeriesId}/cancel`, {
        method  : 'PATCH',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to cancel event series');
}

export async function cancelBooking(bookingId, withCreditRefund) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/bookings/${bookingId}/cancel`, {
        method  : 'POST',
        body    : JSON.stringify({withCreditRefund : withCreditRefund}),
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to cancel booking');
}

export async function findEventListItemsWithPagination(page, limit, filterFromDate, filterStatus = null, signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);

    if (filterFromDate) {
        params.append('fromDate', filterFromDate);
    }

    if (filterStatus) {
        params.append('status', filterStatus);
    }

    const queryString = params.toString();

    const response = await fetch(`${API_URL}/api/event-list-items?${queryString}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch events');

    return response.json();
}

export async function sendInvoice(invoiceId) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/invoices/${invoiceId}/send`, {
        method  : 'POST',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to send invoice');
}

export async function cancelEvent(eventId) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/events/${eventId}/cancel`, {
        method  : 'POST',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to cancel event');
}

export async function uncancelEvent(eventId) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/events/${eventId}/uncancel`, {
        method  : 'POST',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to uncancel event');
}

export async function getMonthlyInvoicesZip(yearMonth) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/invoices/zip?yearMonth=${yearMonth}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/zip',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to fetch monthly invoices zip');

    return await response.blob();
}

export async function getOrdersReport(fromDate, toDate) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/orders/report?fromDate=${fromDate}&toDate=${toDate}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'text/csv',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to fetch orders report');

    return await response.blob();
}

export async function getPaymentsReport(fromDate, toDate) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/payments/report?fromDate=${fromDate}&toDate=${toDate}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'text/csv',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to fetch payments report');

    return await response.blob();
}

export async function getPayoutsReport(fromDate, toDate) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/payouts/report?fromDate=${fromDate}&toDate=${toDate}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'text/csv',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to fetch payouts report');

    return await response.blob();
}

export async function getTrainer(trainerId) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/trainers/${trainerId}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to fetch trainer');

    return await response.json();
}

export async function createTrainer(firstName, lastName, displayName) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/trainers`, {
        method  : 'POST',
        body    : JSON.stringify({
            firstName   : firstName,
            lastName    : lastName,
            displayName : displayName
        }),
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to create trainer');
}

export async function updateTrainer(trainerId, firstName, lastName, displayName) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/trainers/${trainerId}`, {
        method  : 'PATCH',
        body    : JSON.stringify({
            firstName   : firstName,
            lastName    : lastName,
            displayName : displayName
        }),
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to update trainer');
}

export async function findTrainersWithPagination(page, limit, signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);

    const queryString = params.toString();

    const response = await fetch(`${API_URL}/api/trainers?${queryString}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch trainers');

    return response.json();
}

export async function findPayoutsWithPagination(page, limit, fromDate = null, toDate = null, signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);

    if (fromDate) {
        params.append('fromDate', fromDate);
    }

    if (toDate) {
        params.append('toDate', toDate);
    }

    const queryString = params.toString();

    const response = await fetch(`${API_URL}/api/payouts?${queryString}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch payouts');

    return response.json();
}

export async function findPayoutTransactionsWithPagination(payoutId, page, limit, signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);

    const queryString = params.toString();

    const response = await fetch(`${API_URL}/api/payouts/${payoutId}/transactions?${queryString}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch payout transactions');

    return response.json();
}

export async function getStripePayout(payoutId) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/stripe-payouts/${payoutId}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to fetch stripe payout');

    return response.json();
}

export async function getPayout(payoutId) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/payouts/${payoutId}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to fetch payout');

    return response.json();
}

export async function findMollieSettlementsWithPagination(page, limit, fromDate = null, toDate = null, signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);

    if (fromDate) {
        params.append('fromDate', fromDate);
    }

    if (toDate) {
        params.append('toDate', toDate);
    }

    const queryString = params.toString();

    const response = await fetch(`${API_URL}/api/mollie-settlements?${queryString}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch mollie settlements');

    return response.json();
}

export async function getMollieSettlement(settlementId, signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/mollie-settlements/${settlementId}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch mollie settlement');

    return response.json();
}

export async function findMollieSettlementTransactionsWithPagination(settlementId, page, limit, signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);

    const queryString = params.toString();

    const response = await fetch(`${API_URL}/api/mollie-settlements/${settlementId}/transactions?${queryString}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch mollie settlement transactions');

    return response.json();
}

export async function getMollieSettlementsReport(fromDate, toDate) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/mollie-settlements/report?fromDate=${fromDate}&toDate=${toDate}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'text/csv',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to fetch mollie settlements report');

    return await response.blob();
}

export async function findProductFreePairsWithPagination(page, limit, signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);

    const queryString = params.toString();

    const response = await fetch(`${API_URL}/api/product-free-pairs?${queryString}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch product free pairs');

    return response.json();
}

export async function getProductFreePair(productFreePairId) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/product-free-pairs/${productFreePairId}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to fetch product free pair');

    return response.json();
}

export async function createProductFreePair(purchaseProductId, freeProductId) {
    if (!purchaseProductId || !freeProductId) {
        throw new Error("Both purchaseProductId and freeProductId are required.");
    }

    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/product-free-pairs`, {
        method  : 'POST',
        body    : JSON.stringify({
            purchaseProductId : purchaseProductId,
            freeProductId     : freeProductId
        }),
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to create product free pair');
}

export async function deleteProductFreePair(productFreePairId) {
    if (!productFreePairId) {
        throw new Error("The productFreePairId is required.");
    }

    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/product-free-pairs/${productFreePairId}`, {
        method  : 'DELETE',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to delete product free pair');
}

export async function updateProductFreePair(productFreePairId, freeProductId) {
    if (!productFreePairId || !freeProductId) {
        throw new Error("Both productFreePairId and freeProductId are required.");
    }

    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/product-free-pairs/${productFreePairId}`, {
        method  : 'PATCH',
        body    : JSON.stringify({
            freeProductId : freeProductId
        }),
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to update product free pair');
}

export async function findOrderItemsWithPagination(orderId, page, limit, signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);

    const queryString = params.toString();

    const response = await fetch(`${API_URL}/api/orders/${orderId}/items?${queryString}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch order items');

    return response.json();
}

export async function getOrder(orderId) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/orders/${orderId}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to fetch order');

    return response.json();
}

export async function findCouponsWithPagination(page, limit, signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);

    const queryString = params.toString();

    const response = await fetch(`${API_URL}/api/coupons?${queryString}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch coupons');

    return response.json();
}

export async function getCoupon(couponId) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/coupons/${couponId}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to fetch coupon');

    return response.json();
}

export async function createCoupon({
    code,
    name,
    type,
    description = null,
    amount = null,
    percentage = null,
    validFrom,
    validTo,
    availableCount,
    maxUsesPerCustomer,
    isPublic,
    isGlobal,
    singleUsePerBookingGroup,
    customerIds = null,
    productIds = null,
    itemIds = null,
    isAnyPaymentMethod,
    paymentMethods,
}) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/coupons`, {
        method  : 'POST',
        body    : JSON.stringify({
            code                     : code,
            name                     : name,
            type                     : type,
            description              : description,
            amount                   : amount,
            percentage               : percentage,
            validFrom                : validFrom,
            validTo                  : validTo,
            availableCount           : availableCount,
            maxUsesPerCustomer       : maxUsesPerCustomer,
            isPublic                 : isPublic,
            isGlobal                 : isGlobal,
            customerIds              : customerIds,
            productIds               : productIds,
            itemIds                  : itemIds,
            singleUsePerBookingGroup : singleUsePerBookingGroup,
            isAnyPaymentMethod       : isAnyPaymentMethod,
            paymentMethods           : paymentMethods,
        }),
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to create coupon');
}

// The type is not taken: the API does not let a coupon change its type.
export async function updateCoupon(couponId, {
    code,
    name,
    description = null,
    amount = null,
    percentage = null,
    validFrom,
    validTo,
    availableCount,
    maxUsesPerCustomer,
    isPublic,
    isGlobal,
    singleUsePerBookingGroup,
    customerIds = null,
    productIds = null,
    itemIds = null,
    isAnyPaymentMethod,
    paymentMethods
}) {
    if (!couponId) {
        throw new Error("The couponId is required.");
    }

    const token = localStorage.getItem('ACCESS_TOKEN');

    const data = {
        code                     : code,
        name                     : name,
        description              : description,
        amount                   : amount,
        percentage               : percentage,
        validFrom                : validFrom,
        validTo                  : validTo,
        availableCount           : availableCount,
        maxUsesPerCustomer       : maxUsesPerCustomer,
        isPublic                 : isPublic,
        isGlobal                 : isGlobal,
        singleUsePerBookingGroup : singleUsePerBookingGroup,
        isAnyPaymentMethod       : isAnyPaymentMethod,
        // PATCH replaces the whole list, so it is always sent.
        paymentMethods           : paymentMethods,
    };

    if (customerIds !== null) {
        data.customerIds = customerIds;
    }

    if (productIds !== null) {
        data.productIds = productIds;
    }

    if (itemIds !== null) {
        data.itemIds = itemIds;
    }

    const response = await fetch(`${API_URL}/api/coupons/${couponId}`, {
        method  : 'PATCH',
        body    : JSON.stringify(data),
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to update coupon');
}

export async function deleteCoupon(couponId) {
    if (!couponId) {
        throw new Error("The couponId is required.");
    }

    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/coupons/${couponId}`, {
        method  : 'DELETE',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to delete coupon');
}
